import React, { useEffect, useState } from "react";
import "react-phone-input-2/lib/style.css";

import DupontCheckbox from "components/DupontCheckbox";
import DupontDialog from "components/DupontDialog";
import { userProfileStrings, valueStrings } from "constants/constantStrings";
import "./index.scss";

export default function NotificationDeleteForm(props) {
  const { selectedRow, onDeleteDialogClose, isOverlayLoader } = props;
  const [deleteAllSystems, setDeleteAllSystems] = useState(false);
  const [hideDeleteAllSystems, setHideDeleteAllSystems] = useState(false);

  useEffect(() => {
    if (selectedRow.systemAssigned === 1) {
      setHideDeleteAllSystems(true);
      setDeleteAllSystems(true);
    }
  }, [selectedRow]);

  const getDeleteDlgTitle = () => {
    return userProfileStrings.deleteTitle.replace("[name]", selectedRow.Email).replace("[systemName]", selectedRow.SystemName);
  };

  const onDeleteAllSystemChange = value => setDeleteAllSystems(value);
  const onDialogClose = action => onDeleteDialogClose(action, { ...selectedRow, deleteAllSystems });

  return (
    <DupontDialog
      open
      type="primary"
      title={getDeleteDlgTitle()}
      cancelBtnText={valueStrings.no}
      confirmBtnText={valueStrings.yes}
      onClose={onDialogClose}
      isOverlayLoader={isOverlayLoader}
    >
      {userProfileStrings.notificationDeleteDescription}
      {selectedRow.systemAssigned !== 1 && (
        <div className="delete-dialog__checkbox">
          <DupontCheckbox
            labelText={userProfileStrings.deleteAllConfirmation.replace("[name]", selectedRow?.Email)}
            customClass="descriptionWhiteText flex-jc-center "
            onChange={onDeleteAllSystemChange}
          />
        </div>
      )}
    </DupontDialog>
  );
}
